import React from "react";
import { CXContext } from "./cxContext";
import * as dc from "dc";
import * as d3 from 'd3';
import { rhythm } from "../utils/typography.js";
import { css } from "glamor";

export const TagTemplate = props => {
    /*
    We render the dc chart using an effect. We want to pass the chart as a prop after the dc call,
    but there is nothing by default to trigger a re-render and the prop, by default would be undefined.
    To solve this, we hold a state key and increment it after the effect ran.
    By passing the key to the parent div, we get a rerender once the chart is defined.
    */
  const context = React.useContext(CXContext);
  const [chart,updateChart] = React.useState(null);
  const ndx = context.ndx;
  const tags = context.tags;

  const index = React.useRef(null);
  const div = React.useRef(null);

  React.useEffect(() => {
  const key = props.index;
  console.log(key);
  const newChart = props.chartFunction(div.current, ndx, tags, key); // chartfunction takes the ref and does something with it
  newChart.render();
  updateChart(newChart);
  },1); /*Run this exactly once */

  const chartStyles  = css({
    width:'100%',
    //maxWidth: '50px',
    height:'auto',
    boxSizing:'border-box',
    padding:rhythm(.1),
    paddingRight: rhythm(.01),
    '& label':{
      textTransform:'capitalize',
      //textDecoration:'underline',
    }
  })

  return (
    <div
      ref={div}
      {...chartStyles}
      >
    </div>
  );
}
